/**
 * The related layout components rollouts.
 */
export const ROLLOUTS = {
    ANTS_BI_EVENTS: 'ants_bi_events',
ANTS_LAYOUT_USER_REALTIME_COMPONENT: 'ants_layout_user_realtime_component',
GOATS_APP_BOTTOM_SHEET_MOBILE: 'goats_app_bottom_sheet_mobile',
BUSINESS_PROJECTS_SEPARATION_SWITCH: 'business_projects_separation_switch',
CARIBOU_ACCOUNT_SETTINGS: 'caribou_account_settings',
DOLPHINS_ACQUISITION_FLOWS_SEAMLESS_REG: 'dolphins_acquisition_flows_seamless_reg',
DOLPHINS_ACQUISITION_MODALS_SUBSCRIPTION: 'dolphins_acquisition_modals_subscription',
DOLPHINS_AVATAR_MENU_PRO_FEATURES_EXPERIMENT: 'dolphins_avatar_menu_pro_features_experiment',
DOLPHINS_JOB_POST_MIGRATION: 'dolphins_job_post_migration',
DOLPHINS_LOHP_PRO_NEW_HEADER: 'dolphins_lohp_pro_new_header',
DOLPHINS_PRO_AVATAR_MENU: 'dolphins_pro_avatar_menu',
DOLPHINS_PRO_LOHP_DROPDOWN_MENU: 'dolphins_pro_lohp_dropdown_menu',
DOLPHINS_REWARDS_LAUNCH: 'dolphins_rewards_launch',
DOLPHINS_SEAMLESS_REG_NO_SIZE_JUST_ME: 'dolphins_seamless_reg_no_size_just_me',
FIVERR_SELECT: 'fiverr_select',
GTM_ENABLED: 'gtm_enabled',
GOATS_GUEST_BOTTOM_APP_BANNER: 'goats_guest_bottom_app_banner',
HAWKS_FOOTER_SHOW_FREELANCER_EQUITY_PROGRAM: 'hawks_footer_show_freelancer_equity_program',
PROMOTED_GIGS_SEARCH_BAR: 'promoted_gigs_search_bar',
LAYOUT_RELEASE_MESSAGE: 'layout_release_message',
LIONS_MIGRATE_UPDATE_ROUTES_TO_V_FIVE: 'lions_migrate_update_routes_to_v_five',
LIONS_NAVIGATION_ITEMS_FOR_GERMAN_AUDIENCE: 'lions_navigation_items_for_german_audience',
LIONS_BANNER_LOCAL_SITE_REDIRECT: 'lions_banner_local_site_redirect',
LYNXES_IDENTIFICATION_CORE_RESET_PASSWORD_FLOW: 'lynxes_identification_core_reset_password_flow',
LYNXES_IDENTIFICATION_ILLUSTRATION_RIGHT: 'lynxes_identification_illustration_right',
LYNXES_MUSTANGS_DM_BRIEF_CREATION_LAYOUT_COMPONENTS: 'lynxes_mustangs_dm_brief_creation_layout_components',
MEERKATS_LOHP_REVAMP_TEST_OUT: 'meerkats_lohp_revamp_test_out',
MEERKATS_LOHP_REVAMP_RELEASE: 'meerkats_lohp_revamp_release',
MUSTANGS_LOYALTY_INDICATION_SAFETY: 'mustangs_loyalty_indication_safety',
MUSTANGS_ROUTING_SEARCH_BAR: 'mustangs_routing_search_bar',
PERIMETERX: 'perimeterx',
PROFESSION_BASED_CATALOG_RELEASE_MESSAGE: 'profession_based_catalog_release_message',
PROJECT_PARTNER_HEADER: 'project_partner_header',
REAL_USERS_PERFORMANCE_MONITORING: 'real_users_performance_monitoring',
REAL_USERS_PERFORMANCE_MONITORING_NEXT: 'real_users_performance_monitoring_next',
CAT_RV_DATA_FETCH_SEARCH_BAR: 'cat_rv_data_fetch_search_bar',
QUALAS_SELLER_ANALYTICS_LOYALTY: 'qualas_seller_analytics_loyalty',
SELLER_QUICK_SEARCH_NAVIGATION: 'seller_quick_search_navigation',
DRAGONS_SELLER_REFERRALS_DASHBOARD: 'dragons_seller_referrals_dashboard',
DRAGONS_SELLER_REFERRALS: 'dragons_seller_referrals',
SHOW_ORDERS_NAVIGATOR_TO_RESTRICTED_USERS: 'show_orders_navigator_to_restricted_users',
STARLINGS_FIVERR_GO_FLOATING_CHAT: 'starlings_fiverr_go_floating_chat',
STARLINGS_PA_FILE_ANALYSIS_FE: 'starlings_pa_file_analysis_fe',
STARLINGS_PA_LINK_ANALYSIS_FE: 'starlings_pa_link_analysis_fe',
DOLPHINS_WINTER_RELEASE_MESSAGE: 'dolphins_winter_release_message',
WOLVES_FIB_BILLING_AREA: 'wolves_fib_billing_area',
ZEBRAS_INVITE_POLICIES_READ_NEW_DB: 'zebras_invite_policies_read_new_db',
ZEBRAS_INVITE_REQUESTS_CREATE_NEW_DB: 'zebras_invite_requests_create_new_db',
ZEBRAS_NEW_LOYALTY_POINTS: 'zebras_new_loyalty_points',
ZEBRAS_NEW_PROJECT_PARTNER_BANNER_IN_SEARCH: 'zebras_new_project_partner_banner_in_search',
ZEBRAS_POLICIES_REQUESTS_PAGE: 'zebras_policies_requests_page',
ZEBRAS_PRO_ADMIN: 'zebras_pro_admin',
ZEBRAS_PRO_SUBSCRIPTION: 'zebras_pro_subscription',
ZIPERS_FREELANCE_NETWORK: 'zipers_freelance_network'
} as const;

export type Rollout = (typeof ROLLOUTS)[keyof typeof ROLLOUTS];
